import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const Navbar = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get("https://ryc-soluciones-nicaragua.com/api/index.php?getAllCategory=true");
        
        const categoriesData = response.data.map((item) => ({
          id: item.id,
          slug: item.slug,
          nombre: item.category
        }));
  
        setCategories(categoriesData); // **Aquí es donde faltaba actualizar el estado**
      } catch (error) {
        console.error("Error al obtener las categorías:", error);
      }
    };
  
    fetchCategories();
  }, []);  

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/productos?search=${encodeURIComponent(searchQuery)}`);
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark" style={{ backgroundColor: "#00377b" }}>
      <div className="container">
        {/* Botón para móviles */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Enlace para desktop y tablet (círculo) */}
        <Link
          className="navbar-brand d-none d-sm-flex flex-column justify-content-center align-items-center rounded-circle text-light"
          to="/"
          style={{
            width: "70px",
            height: "70px",
            background: "linear-gradient(to bottom right, #00377b,  #00377b)",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
            color: "white",
            fontWeight: "bold",
            fontSize: "16px",
            textDecoration: "none",
            textAlign: "center",
            lineHeight: "1.2",
          }}
        >
          RyC
          <div style={{ fontSize: "10px", marginTop: "4px", textTransform: "uppercase", fontWeight: "normal" }}>
            Nicaragua
          </div>
        </Link>

        {/* Enlace para móviles (solo texto) */}
        <Link
          className="navbar-brand d-block d-sm-none text-light text-center"
          to="/"
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            textDecoration: "none",
          }}
        >
          RyC Soluciones Nicaragua
        </Link>

        <div className="collapse navbar-collapse d-flex flex-wrap align-items-center" id="navbarNav">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            {/* Renderizar categorías dinámicamente */}
            {categories.length > 0 ? (
              categories.map((category, index) => (
                <li
                  className={`nav-item text-nowrap ${index !== categories.length - 1 ? 'border-end' : ''}`}
                  key={category.id}
                >
                  <Link
                    className="nav-link text-light"
                    to={`/productos/${category.nombre.replaceAll(" ", "-")}`}
                    style={{
                      paddingRight: "15px", // Ajuste para espacio extra a la derecha
                    }}
                  >
                    {category.nombre}
                  </Link>
                </li>
              ))
            ) : (
              <li className="nav-item">
                <span className="nav-link text-light">Cargando...</span>
              </li>
            )}
            <li className="nav-item" style={{ borderLeft: "1px solid white", paddingLeft: "10px" }}>
              <button
                className="nav-link btn btn-link text-light"
                style={{ cursor: "pointer", textDecoration: "none" }}
                data-bs-toggle="modal"
                data-bs-target="#contactModal"
              >
                Contáctanos
              </button>
            </li>
          </ul>

          <form className="d-flex ms-auto" onSubmit={handleSearchSubmit}>
            <input
              className="form-control me-2"
              type="search"
              placeholder="Buscar producto"
              aria-label="Buscar"
              value={searchQuery}
              onChange={handleSearchChange}
            />
            <button className="btn btn-outline-light" type="submit">
              Buscar
            </button>
          </form>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
